var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuizRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6272 18.6272 24 12 24C5.37278 24 0 18.6272 0 12C0 5.37278 5.37278 0 12 0C18.6272 0 24 5.37278 24 12Z",
    fill: "#7E57C2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23857_60234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9982 23.9965C18.6247 23.9965 23.9965 18.6247 23.9965 11.9982C23.9965 5.3718 18.6247 0 11.9982 0C5.3718 0 0 5.3718 0 11.9982C0 18.6247 5.3718 23.9965 11.9982 23.9965Z",
    fill: "#7E57C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08026 5.98047H17.1977V18.5588H6.80957V5.98047H7.08026ZM11.1828 7.3515H15.556V7.89639H11.1828V7.34446V7.3515ZM11.1828 8.71549H14.192V9.2639H11.1828V8.71549ZM11.1828 11.1763H15.556V11.7247H11.1828V11.1763ZM11.1828 12.5438H14.192V13.0887H11.1828V12.5438ZM11.1828 15.0046H15.556V15.5495H11.1828V15.0046ZM11.1828 16.3721H14.192V16.917H11.1828V16.3721ZM8.44777 16.917H9.8188V15.5495H8.44777V16.917ZM10.0895 17.4655H7.90288V15.0046H10.3637V17.4655H10.0895ZM8.44777 13.0887H9.8188V11.7247H8.44777V13.0887ZM10.0895 13.6371H7.90288V11.1763H10.3637V13.6371H10.0895ZM8.44777 9.2639H9.8188V7.89288H8.44777V9.2639ZM10.0895 9.8088H7.90288V7.34798H10.3637V9.8088H10.0895Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23857_60234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizRounded);
export default __webpack_public_path__ + "static/media/quiz-rounded.ae1a505e7700d610a731205a5ab44133.svg";
export { ForwardRef as ReactComponent };